import { z } from "zod";

/**
 * Upfront action for phone calls (different structure than SMS)
 */
export const PhoneCallUpfrontActionSchema = z.object({
  sequenceType: z.enum(["parallel", "serial"]),
  actions: z.array(
    z.object({
      name: z.string(),
      input: z.unknown(),
      description: z.string()
    })
  )
});

export type PhoneCallUpfrontAction = z.infer<typeof PhoneCallUpfrontActionSchema>;
